<template>
  <div class="container_inner_main">
    <div style="display: flex;align-items: center">
      <div style="display: flex;align-items: center">
        <div class="simple_text">
          机关:
        </div>
        <el-input v-model="checkInfo.organs" placeholder="请输入完整机关名称" class="my-input"></el-input>
      </div>
      <div style="display: flex;align-items: center">
        <div class="simple_text">
          部门:
        </div>
        <el-input v-model="checkInfo.dpName" placeholder="请输入完整部门名称" class="my-input"></el-input>
      </div>

      <el-button type="primary" icon="el-icon-search" @click="checkInfo.currIndex =1,ritialInfo()" style="margin-left: 10px">搜索</el-button>
      <el-button icon="el-icon-delete" @click="clear">清空</el-button>
      <el-button type="primary"  icon="el-icon-plus" @click="clickToCreate">新建</el-button>

    </div>
    <div>

    </div>

    <el-table
        class="mtable"
        :data="departList"
        @row-click="onRowClick"
        border>

      <el-table-column min-width="10%" align="center" property="sort" label="序号">
<!--        <template slot-scope="scope">-->
<!--          {{ departList.indexOf(scope.row) + 1 }}-->
<!--        </template>-->
      </el-table-column>
      <el-table-column min-width="25%" property="organs" label="机关"></el-table-column>
      <el-table-column min-width="25%" property="dpName" label="部门"></el-table-column>
      <el-table-column min-width="25%" property="type" label="部门类型"></el-table-column>
      <el-table-column min-width="25%" align="center" label="操作">
        <template slot-scope="scope">
          <div>
            <el-button icon="el-icon-edit" type="text" @click="clickToEdit(scope.row)">修改</el-button>
            <el-button class="uni_btn" icon="el-icon-delete" type="text" @click="deleteDepart(scope.row)">删除
            </el-button>
            <el-button icon="el-icon-sort" type="text" @click="clickToSort(scope.row)">排序</el-button>
          </div>
        </template>
      </el-table-column>

    </el-table>

    <el-pagination
        background
        layout="total, prev, pager, next"
        v-if="departList.length"
        :total="total"
        @current-change="handleCurrentChange"
        :current-page=checkInfo.currIndex
        :page-size=checkInfo.pageSize
        style="text-align: center"
    >
    </el-pagination>

    <el-dialog
        :visible.sync="dialog_create"
        :lock-scroll="false"
        title="新建"
        :close-on-click-modal="false">

      <div class="container_inner_dialog">

        <div style="display: flex;align-items: center">
          <div class="style_text_font">
            <span style="color: red">*</span>
            机关名称
          </div>
          <el-input v-model="createInfo.organs" placeholder="请输入名称" class="my-input" maxlength="20"
                    show-word-limit></el-input>


        </div>
        <div style="display: flex;align-items: center">
          <div class="style_text_font">部门名称</div>
          <el-input v-model="createInfo.dpName" placeholder="请输入名称" class="my-input" maxlength="20"
                    show-word-limit></el-input>
        </div>
        <div style="display: flex;align-items: center">
          <div class="style_text_font"><span style="color: red">*</span>部门类型</div>
          <el-select v-model="createInfo.type" class="my-input" placeholder="请选择部门类型">
            <el-option
                    v-for="item in typeList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
            </el-option>
          </el-select>
        </div>

        <div style="float: right">
          <el-button type="primary" @click="upload">保存</el-button>
          <el-button @click="cancelCreate">取消</el-button>
        </div>
      </div>
    </el-dialog>


    <el-dialog
        :visible.sync="dialog_edit"
        :lock-scroll="false"
        title="修改"
        :close-on-click-modal="false">

      <div class="container_inner_dialog">

        <div style="display: flex;align-items: center">
          <div class="style_text_font">
            <span style="color: red">*</span>
            机关名称
          </div>
          <el-input v-model="editInfo.organs" placeholder="请输入名称" class="my-input" maxlength="20"
                    show-word-limit></el-input>


        </div>
        <div style="display: flex;align-items: center">
          <div class="style_text_font">部门名称</div>
          <el-input v-model="editInfo.dpName" placeholder="请输入名称" class="my-input" maxlength="20"
                    show-word-limit></el-input>
        </div>
        <div style="display: flex;align-items: center">
          <div class="style_text_font"><span style="color: red">*</span>部门类型</div>
          <el-select v-model="editInfo.type" class="my-input" placeholder="请选择部门类型">
            <el-option
                    v-for="item in typeList"
                    :key="item.name"
                    :label="item.name"
                    :value="item.name">
            </el-option>
          </el-select>
        </div>


        <div style="float: right">
          <el-button type="primary" @click="modify">修改</el-button>
          <el-button @click="cancelEdit">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
            :visible.sync="sortVisible"
            width="30%"
            :lock-scroll="false"
            title="排序"
            :close-on-click-modal="false">

      <div class="container_inner_dialog">

        <div style="display: flex;align-items: center">
          <div class="style_text_font">
            序号
          </div>
          <el-input v-model="sort" placeholder="请输入序号" class="my-input"  oninput="value=value.replace(/^0|[^0-9]/g,'')" ></el-input>
        </div>

        <div style="float: right">
          <el-button type="primary" @click="editSort">修改</el-button>
          <el-button @click="cancelSort">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addPart, delPart, getPartList, updatePart, updateSort} from "@/api/api";
import {Message} from "element-ui";
import {formatDate, ssDateTimeFn} from "@/utils/time";
// import getFormData from "@/utils/check-empty";
export default {
  name: "department",
  data() {
    return {

      departList: [],
      total:0,
      checkInfo: {
        currIndex: 1,
        pageSize: 8,
        dpName:'',
        organs:''
      },

      typeList:[
        {name:'区四套班子'},
        {name:'机关部门'},
        {name:'区属国企'},
        {name:'系统单位'},
        {name:'园区镇街'},
        {name:'村、社区'},
        {name:'重点企业'}
        ],
      dialog_create: false,
      dialog_edit: false,
      sortVisible:false,
      currentInfo: '',
      createInfo: {
        dpName: '',
        organs: '',
        status:1,
        type:'',
        createTime: '',
        createUser: ''
      },
      sort:null,
      editInfo: {
        dpName: '',
        organs: '',
        type:''
      },
    }
  },
  created() {
    this.ritialInfo()
  },
  methods: {
    ritialInfo() {
      this.departList = []
      getPartList(this.checkInfo).then(res => {
        if (res.data.code === '0000') {
          this.total=res.data.data.total;

          this.departList = res.data.data.dataList;
        } else {
          Message.warning(res.data.message);
          if (res.data.code==='10007'){
            this.$router.push('/login');
          }
          // Message.warning(res.data.message);
        }
      })
    },
    clear() {
      this.checkInfo={
        currIndex: 1,
        pageSize: 8,
        dpName:'',
        organs:''
      }
      this.ritialInfo()
    },
    clickToCreate() {
      this.dialog_create = true
      this.createInfo = {
        dpName: '',
        organs: '',
        status:1,
        type:'',
        createTime: '',
        createUser: ''
      }
    },

    clickToEdit(row) {
      this.currentInfo = row;
      this.editInfo.dpName = row.dpName;
      this.editInfo.organs = row.organs;
      this.editInfo.type = row.type;
      this.dialog_edit = true
    },
    clickToSort(row){
      this.currentInfo = row;
      this.sort = row.sort;
      this.sortVisible = true;
    },
    handleCurrentChange(val) {
      this.checkInfo.currIndex = val;
      this.ritialInfo()
    },

    cancelCreate() {
      this.dialog_create = false
    },
    cancelEdit() {
      this.dialog_edit = false
    },
    cancelSort(){
      this.sortVisible = false
    },

    checkEmpty(aim) {
      return aim != null && aim !== '' && aim.length > 0
    },
    checkRepeatDpName(name, index) {
      let noRepeat = true;
      this.departList.forEach(item => {
        if (item.dpName === name) {
          if (index !== '') {
            if (this.departList.indexOf(item) !== index) {
              noRepeat = false;
            }
          } else {
            noRepeat = false;
          }

        }
      })
      return noRepeat;
    },
    checkRepeatOrgName(name, index) {
      let noRepeat = true;
      this.departList.forEach(item => {
        if (item.organs === name) {
          if (index !== '') {
            if (this.departList.indexOf(item) !== index) {
              noRepeat = false;
            }
          } else {
            noRepeat = false;
          }

        }
      })
      return noRepeat;
    },

    upload() {
      if (!this.checkEmpty(this.createInfo.organs)) {
        this.$message.warning("请输入机关名称")
        return
      }
      console.log(this.createInfo.type)
      if (!this.checkEmpty(this.createInfo.type)) {
        this.$message.warning("请选择部门类型")
        return
      }
      if (!this.checkRepeatOrgName(this.createInfo.organs)) {
        if (!this.checkRepeatDpName(this.createInfo.dpName)) {
          this.$message.warning("请不要输入重复的名称")
          return
        }
      }
      let user=localStorage.getItem('CurrentUser');
      this.createInfo.createUser=user?user:'admin';
      this.createInfo.createTime=ssDateTimeFn(new Date())
      addPart(this.createInfo).then(res => {
        if (res.data.code === '0000') {
          Message.success(res.data.message);
          this.dialog_create=false
          this.ritialInfo()

        } else {
          Message.warning(res.data.message);
          if (res.data.code==='10007'){
            this.$router.push('/login');
          }
          // Message.warning(res.data.message);
        }
      })
    },

    modify() {
      if (!this.checkEmpty(this.editInfo.organs)) {
        this.$message.warning("请输入机关名称")
        return
      }
      if (!this.checkEmpty(this.editInfo.type)) {
        this.$message.warning("请选择部门类型")
        return
      }
      if (!this.checkRepeatOrgName(this.editInfo.organs, this.departList.indexOf(this.currentInfo))) {
        if (!this.checkRepeatDpName(this.editInfo.dpName, this.departList.indexOf(this.currentInfo))) {
          this.$message.warning("请不要输入重复的部门名称")
          return
        }
      }

      this.currentInfo.organs = this.editInfo.organs
      this.currentInfo.dpName = this.editInfo.dpName;
      this.currentInfo.type = this.editInfo.type;
      updatePart(this.currentInfo).then(res => {
        if (res.data.code === '0000') {
          Message.success(res.data.message);
          this.dialog_edit = false;
          this.ritialInfo()
        }else {
          Message.warning(res.data.message);
          if (res.data.code==='10007'){
            this.$router.push('/login');
          }
          // Message.warning(res.data.message);
        }
      })
    },
    editSort(){
      if (!this.checkEmpty(this.sort)) {
        this.$message.warning("请输入序号")
        return
      }
      this.currentInfo.sort = this.sort;
      updateSort(this.currentInfo).then(res => {
        if (res.data.code === '0000') {
          Message.success(res.data.message);
          this.sortVisible = false;
          this.ritialInfo()
        }else {
          Message.warning(res.data.message);
          if (res.data.code==='10007'){
            this.$router.push('/login');
          }
          // Message.warning(res.data.message);
        }
      })
    },

    deleteDepart(row) {
      this.currentInfo = row
      this.$confirm('此操作将删除[' + this.currentInfo.organs + ']的' + '[' + this.currentInfo.dpName + ']' + '，是否继续？', '删除部门', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delPart(this.currentInfo.id).then(res => {
              if (res.data.code === '0000') {
                this.ritialInfo()
                Message.success(res.data.message);
              } else {
                Message.warning(res.data.message);
                if (res.data.code==='10007'){
                  this.$router.push('/login');
                }
                // Message.warning(res.data.message);
              }
            }
        )
      }).catch(() => {

      })
    },
    onRowClick(row, event, colum) {
      this.currentInfo = row
    }
  }
}
</script>

<style scoped>
  .simple_text {
    font-size: 17px;
    text-align: center;
    margin: 0 5px;
    width: 90px;
  }
.container_inner_main {
  /*width: 100%;*/
  /*height: 100%;*/
}

.mtable {
  font-size: 17px;
  margin: 20px 0;
  width: 90%;
}

.my-input {
  font-size: 17px;
  width: 100%;
  margin: 10px;
}

.container_inner_dialog {
  margin-bottom: 20px;
}

/deep/ .uni_btn.el-button--text {
  color: red !important;
}

.style_text_font{
  font-size: 17px;
  width: 100px;
  text-align: right
}
/deep/.el-input{
  font-size: 17px;

}
</style>
